const winner = (speakers) =>
  [...speakers].sort((a, b) => b.points - a.points)[0];

export default function SpeakerPoints({
  speakers,
  bestSpeakerId,
  onSpeakerChange,
  onBestSpeakerChange,
}) {
  const suggested = winner(speakers);
  const selected =
    bestSpeakerId === "auto"
      ? suggested
      : speakers.find((speaker) => speaker.id === bestSpeakerId);

  return (
    <section
      className="speaker-points section-reveal delay-two"
      data-testid="speaker-points-section"
    >
      <div className="section-heading">
        <div>
          <p className="eyebrow">Speaker awards</p>
          <h2>Speaker points</h2>
        </div>
        <span className="formula-label">25.0 — 30.0</span>
      </div>
      <p className="speaker-points-guidance" data-testid="speaker-points-guidance">
        Enter each speaker&apos;s points based on your own judgment of their performance.
      </p>
      <div className="speaker-grid">
        {speakers.map((speaker) => (
          <div
            className={`speaker-row ${speaker.team}`}
            key={speaker.id}
            data-testid={`speaker-row-${speaker.id}`}
          >
            <span className="team-dot"></span>
            <input
              value={speaker.name}
              onChange={(event) =>
                onSpeakerChange(speaker.id, "name", event.target.value)
              }
              aria-label={`${speaker.id} name`}
              data-testid={`speaker-name-${speaker.id}`}
            />
            <input
              type="number"
              min="25"
              max="30"
              step="0.1"
              value={speaker.points}
              onChange={(event) =>
                onSpeakerChange(
                  speaker.id,
                  "points",
                  Number(event.target.value),
                )
              }
              aria-label={`${speaker.id} points`}
              data-testid={`speaker-points-${speaker.id}`}
            />
          </div>
        ))}
      </div>
      <div className="best-speaker">
        <div>
          <p>Best speaker</p>
          <strong data-testid="best-speaker-suggestion">
            {selected?.name || "Choose a speaker"}
          </strong>
        </div>
        <select
          value={bestSpeakerId}
          onChange={(event) => onBestSpeakerChange(event.target.value)}
          data-testid="best-speaker-select"
        >
          <option value="auto">Suggested — highest points</option>
          {speakers.map((speaker) => (
            <option key={speaker.id} value={speaker.id}>
              {speaker.name || "Unnamed speaker"}
            </option>
          ))}
        </select>
      </div>
    </section>
  );
}
